import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=08882452&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=08882452&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08882452",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Burger: require('/codebuild/output/src1887633789/src/kokalanov/components/Burger.vue').default})
